import { render } from "./ExpertCard.vue?vue&type=template&id=8e6ed8f6&scoped=true"
import script from "./ExpertCard.vue?vue&type=script&lang=js"
export * from "./ExpertCard.vue?vue&type=script&lang=js"

import "./ExpertCard.vue?vue&type=style&index=0&id=8e6ed8f6&scoped=true&lang=css"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6ed8f6"]])

export default __exports__